export const INDENTIFIER = {
  INPUTTEXT: 'INPUTTEXT',
  DATEPICKER: 'DATEPICKER'
}